import React, { useState } from 'react'
import UserIcon from '../lib/userIcon';
import UserMenu from './userMenu';
import TopMenu from './topMenu';
import { NotificationBell } from './NotificationBell';
import { NotificationDrawer } from './NotificationDrawer';
import { useNotifications } from '../../hooks/useNotifications';
import { useIsScreenLarge } from '../../utils/ViewportUtils';

function TopNavBar({ title, subtitle }) {
    const [isMenuOpen, setMenuOpen] = useState(false);
    const [isDrawerOpen, setDrawerOpen] = useState(false);
    const isScreenLarge = useIsScreenLarge();
    const { notifications, unreadCount, markAsRead, markAllAsRead } = useNotifications();

    const toggleMenu = () => {
        setMenuOpen(!isMenuOpen);
    };

    return (
        <div className='w-full h-24 bg-custom_light_bg flex items-center relative'>
            <div className='mx-10 text-custom_lighter_gray_font'>
                <p className="font-bold text-2xl md:text-3xl">{title}</p>
                <p className='font-semibold text-sm md:text-base'>{subtitle}</p>
            </div>

            <div className="flex items-center absolute right-10">
                <NotificationBell unreadCount={unreadCount} onClick={() => setDrawerOpen(true)} />
                <div className='mx-4'>
                    <UserIcon onClick={toggleMenu} />
                    <UserMenu isOpen={isMenuOpen} onClose={() => setMenuOpen(false)} />
                </div>
                {!isScreenLarge ? (
                    <TopMenu />
                ) : <></>}
            </div>

            <NotificationDrawer
                isOpen={isDrawerOpen}
                onClose={() => setDrawerOpen(false)}
                notifications={notifications}
                unreadCount={unreadCount}
                markAsRead={markAsRead}
                markAllAsRead={markAllAsRead}
            />
        </div>
    )
}

export default TopNavBar